export default class extends Controller {

  connect() {
    this.initializeGrayOutFunction()
  }

  disconnect() {
    this.delayedGrayOut && clearTimeout(this.delayedGrayOut)
  }

  initializeGrayOutFunction() {
    const mSecs = App.DateTime.millisecondsUntil(this.endTime)
    if (mSecs >= 0) {
      const grayOutFunc = (() => this.element.classList.add("complete")).bind(this)
      this.delayedGrayOut = setTimeout(grayOutFunc, mSecs)
    }
  }

  get endTime() {
    return this.data.get("end-time")
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-event-row-controller.js